<template>
	<div class="container">
		<div v-if="news.length == 0" class="iv2-news__items-null row clearfix">
			<div class="column full">
				<div style="padding: 2rem 0;">
					<h4 class="size-28 text-center" style="font-weight: bold;">{{ $t('news.null_title') }}</h4>
					<p class="text-center">{{ $t('news.null_summary') }}</p>
				</div>
			</div>
			<div class="column full">
				<div class="spacer height-60"></div>
			</div>
		</div>
		<div v-else>
			<div class="row clearfix">
				<div class="column full">
					<div class="spacer height-60"></div>
				</div>
				<div v-for="item in news" :key="item.id" class="iv2-news-item mb-5 col-md-6 col-xl-4">
					<router-link :to="{ name: 'newsDetail', params: { id: item.id }}" class="iv2-news-item__link">
						<div class="iv2-news-item__img fit-img">
							<picture>
								<source type="image/webp" :srcset="item.thumbnail + $t('general.image_webp')">
								<img class="m-0" :src="item.thumbnail" :alt="'「' + item.title + '」' + $t('news.alt')">
							</picture>
						</div>

						<div class="iv2-news-item__data mt-4">
							<div class="row">
								<div class="col-6">
									<small v-if="item.opened_at !== null" class="iv2-news-item__date">{{ item.opened_at | moment }}</small>
									<small v-if="isAfter(setDatetime(item.opened_at), end)" class="iv2-news-item__new ml-1"
									>{{ $t('news.new_label') }}</small>
								</div>
								<div class="col-6">
									<small class="iv2-news-item__label d-block">{{ item.category_name }}</small>
								</div>
							</div>
						</div>
						<h3 class="iv2-news-item__title">{{ item.title }}</h3>
					</router-link>
				</div>
				<div class="column full">
					<div class="spacer height-60"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from "moment";
export default {
	props: ["news"],

	data() {
		return {
			start: "",
			end: moment().format(),
		};
	},

	methods: {
		isAfter: function (start, end) {
			return moment(start).isAfter(end);
		},

		setDatetime: function (start) {
			return moment(start).add(13, "days");
		},
	},

	filters: {
		moment: function (created) {
			return moment(created).format("YYYY年MM月DD日");
		},
	},
};
</script>

<style lang="scss">
.iv2-news__items-null {
	padding: 8rem 0;
}

.iv2-news-item .iv2-news-item__link {
	display: block;
	text-decoration: none;

	&:hover .iv2-news-item__img {
		opacity: 0.7;
	}

	.iv2-news-item__img {
		height: 200px;
		-webkit-transition: 0.3s;
		transition: 0.3s;
	}

	.iv2-news-item__title {
		font-size: 1.1rem;
		font-weight: bold;
	}

	.iv2-news-item__new {
		color: #a83535;
	}

	.iv2-news-item__label {
		width: 100%;
		text-align: center;
		border: 1px solid;
	}
}
</style>